import { render } from "./CreateAddress.vue?vue&type=template&id=2e41bc6e&scoped=true"
import script from "./CreateAddress.vue?vue&type=script&lang=js"
export * from "./CreateAddress.vue?vue&type=script&lang=js"

import "./CreateAddress.vue?vue&type=style&index=0&id=2e41bc6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e41bc6e"]])

export default __exports__